import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ContextService } from '@lr/core';

const DOCUMENT_VIEW = 'Document.View';

export const documentViewCanActivate: CanActivateFn = () => {
  const contextService = inject(ContextService);
  const router = inject(Router);

  const permissions = contextService.getPermissions()?.permissions ?? [];
  if (permissions.includes(DOCUMENT_VIEW)) {
    return true;
  }

  router.navigate(['/access-denied'], { replaceUrl: true });
  return false;
};
